module.exports = __webpack_public_path__ + "static/media/DASSM.b9108195.pdf";